// پرچم های تقویمی
export const dateBaseFlags = [
  { id: 2090, title: "تصمیم برای ادامه تحصیل در مقطع کارشناسی" },
  { id: 486, title: "ثبت نام کنکور کارشناسی" },
  { id: 485, title: "مطالعه کنکور کارشناسی" },
  { id: 482, title: "تصمیم برای ادامه تحصیل در مقطع ارشد" },
  { id: 481, title: "ثبت نام کنکور ارشد" },
  { id: 462, title: "مطالعه کنکور ارشد" },
  { id: 2089, title: "تصمیم برای ادامه تحصیل در مقطع دکتری" },
  { id: 2091, title: "مطالعه کنکور دکتری" },
  { id: 1162, title: "اقدام کوتاه مدت تحصیلی" },
  { id: 473, title: "فعالیت دانشجویی" },
  { id: 472, title: "استفاده از فضای آکادمیک دانشگاه" },
  { id: 4803, title: "پایان‌نامه" },
  { id: 484, title: "مطالعه کنکور ارشد یا سربازی" },
  { id: 483, title: "انتخاب رشته ارشد و مطالعه کنکور" },
  { id: 480, title: "ثبت نام دانشگاه" },
  { id: 3256, title: "پایان‌نامه روانشناسی" },
  { id: 3111, title: "تصمیم برای ادامه تحصیل در مقطع دکتری روانشناسی" },
  { id: 2992, title: "مطالعه کنکور ارشد روانشناسی" },
  { id: 1508, title: "کنکور وزارت بهداشت یا وزارت علوم؟" },
  { id: 1492, title: "دروس پیش نیاز (غیرمرتبط‌)" },
  { id: 1464, title: "دروس اختیاری" },
  { id: 1463, title: "دروس عمومی" },
  { id: 1462, title: "دروس تخصصی" },
  { id: 1461, title: "دروس پایه" },
  { id: 1491, title: "مصاحبه دکتری روانشناسی" },
  { id: 1490, title: "منابع کنکور دکتری" },
  { id: 1489, title: "منابع کنکور ارشد روانشناسی" },
  { id: 1488, title: "انتخاب گرایش روانشناسی" },
  { id: 1455, title: "پروپوزال" },
  { id: 1448, title: "تصمیم برای ادامه تحصیل در رشته روانشناسی" },
];
